import { type User } from '@prisma/client'
import { Link } from '@remix-run/react'
import { getUserImgSrc } from '#app/utils/misc.tsx'

interface AvatarProps {
	user: User & {
		lawyerProfile?: { name: string } | null
		image?: { id: string } | null
	}
}

export default function Avatar({ user }: AvatarProps) {
	return (
		<div className="flex items-center">
			<div>
				<img
					className="inline-block h-9 w-9 rounded-full"
					src={getUserImgSrc(user.image?.id)}
					alt={user?.lawyerProfile?.name}
				/>
			</div>
			<div className="ml-3">
				{user.lawyerProfile ? (
					<Link
						to={'/users/' + user.username}
						className="group block flex-shrink-0"
					>
						<p className="text-sm font-medium text-gray-700 group-hover:text-gray-900">
							{user.name}
						</p>
						<p className="text-xs font-medium text-gray-500 group-hover:text-gray-700">
							Ver perfil
						</p>
					</Link>
				) : (
					<p className="text-sm font-medium text-gray-700 group-hover:text-gray-900">
						{user.name}
					</p>
				)}
			</div>
		</div>
	)
}
